import React from 'react';

export const Ellipsis: React.FC = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.3359 12C16.3359 12.1841 16.1866 12.3334 16.0024 12.3334C15.8182 12.3334 15.6689 12.1841 15.6689 12C15.6689 11.8158 15.8182 11.6665 16.0024 11.6665C16.1866 11.6665 16.3359 11.8158 16.3359 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.3339 12C12.3339 12.1841 12.1846 12.3334 12.0005 12.3334C11.8163 12.3334 11.667 12.1841 11.667 12C11.667 11.8158 11.8163 11.6665 12.0005 11.6665C12.1846 11.6665 12.3339 11.8158 12.3339 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33198 12C8.33198 12.1841 8.18268 12.3334 7.99851 12.3334C7.81434 12.3334 7.66504 12.1841 7.66504 12C7.66504 11.8158 7.81434 11.6665 7.99851 11.6665C8.18268 11.6665 8.33198 11.8158 8.33198 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
